import React, { useState, useEffect } from "react";
import { ApiCall } from "../utility/ApiCalls";
import Box from "@mui/system/Box";
import Typography from "@mui/material/Typography";
import axios from "axios";
import AuditHomeTable from "../components/Audit/AuditHomeTable";
import AuditHomeTable2 from "../components/Audit/AuditHomeTable2";

function AuditHome() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  async function getALLAuditData(e) {
    // console.log('Inside getALLAuditData  API call ');
    // const ret = await ApiCall(
    //     {},
    //     "vcare-ui",
    //     "vcareui_clinicaltasklist"
    // );
    // const repsonse = ret.body;
    // console.log('setting state ===================================================== ');
    // console.log("Audithome data-----..//",ret.body);
    // setData(ret.body);
    setLoading(false);
  }
  // const dashboardApi = () => {
  //     axios
  //       .post(`https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_vcareui_clinicaltasklist`, {
  //         StatusCode: "",
  //         ReturnType: "Totals",
  //       })
  //       .then((res) => {
  //         console.log("------------------>>>>",res.data.body);
  //         // setDashboardTasklist(res.data.body);
  //       });
  //   };

  useEffect(() => {
    getALLAuditData();
    // dashboardApi();
  }, []);

  if (loading) {
    return (
      <div>
        <Box className="loader-wrapper">
          <div className="loader"></div>
        </Box>
      </div>
    );
  } else {
    return (
      <>
        <Box className="primary-title-new">
          <img src="img/heading-bg.png" />
          <Typography variant="h1">Clinical Audit Sampling</Typography>
        </Box>
        {/* <AuditHomeTable data={data} /> */}
        <AuditHomeTable2 data={data} />
      </>
    );
  }
}

export default AuditHome;
